/**
 * @file 路由变化时清除模块状态
 */
import store from '@/store'

/**
 * 路由变化时，把之前的弹窗状态都清掉
 * @param {String} module - 模块名称
 */
export function clearState(module) {
    let status = store.state[module]
    if (status) {
        for (let key in status) {
            let property = status[key]
            if (status.hasOwnProperty(key) && property && typeof property === 'boolean') {
                status[key] = false
            }
        }
    }
}

